var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import Dialog from "@/components/common/dialog/Dialog.vue";
import Button from "@/components/ui/button/Button.vue";
import Select from "@/components/ui/select/Select.vue";
import { StepIndicator } from "@/components/ui/step-indicator";
import { sendChangeRequest } from "@/views/results-report/api/changes";
import { computed, ref, watch, onMounted } from "vue";
import { BULK_EDIT_STEPS, BULK_EDIT_STEPS_LIST } from "./types";
import { useBulkEdit } from "./useBulkEdit";
import { currentUser } from "@/core/users/session";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldBulkEditDialog',
    props: {
        data: { type: Array, required: true },
        fields: { type: Array, required: true },
        period: { type: Object, required: true },
        dataRows: { type: Array, required: true },
        tab: { type: String, required: true }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        // Dialog ref
        const dialogRef = ref();
        // Current step
        const currentStep = ref(BULK_EDIT_STEPS_LIST[0]);
        // Result state
        const result = ref(null);
        const isDistribuidor = computed(() => ["E100"].includes(currentUser().region_code));
        const isDelegacionZonaVentas = computed(() => ["E300"].includes(currentUser().region_code));
        const isRedRevisada = computed(() => ["N100", "N300", "E100"].includes(currentUser().region_code));
        const isNumObjetivos = computed(() => ["E300"].includes(currentUser().region_code));
        const isCatalunya = computed(() => currentUser().region_code === "E100");
        // Step configurations
        const stepsForStepper = [
            {
                key: BULK_EDIT_STEPS.SELECT_DELEGATION,
                label: "Seleccionar<br>Distribuidor",
                icon: `<svg width="36" height="29" viewBox="0 0 36 29" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.4 4.53125C5.4 3.81019 5.68446 3.11867 6.19081 2.6088C6.69716 2.09894 7.38392 1.8125 8.1 1.8125C8.81608 1.8125 9.50284 2.09894 10.0092 2.6088C10.5155 3.11867 10.8 3.81019 10.8 4.53125C10.8 5.25231 10.5155 5.94383 10.0092 6.4537C9.50284 6.96356 8.81608 7.25 8.1 7.25C7.38392 7.25 6.69716 6.96356 6.19081 6.4537C5.68446 5.94383 5.4 5.25231 5.4 4.53125ZM12.6 4.53125C12.6 3.32949 12.1259 2.17695 11.282 1.32717C10.4381 0.477398 9.29347 0 8.1 0C6.90653 0 5.76193 0.477398 4.91802 1.32717C4.07411 2.17695 3.6 3.32949 3.6 4.53125C3.6 5.73301 4.07411 6.88555 4.91802 7.73533C5.76193 8.5851 6.90653 9.0625 8.1 9.0625C9.29347 9.0625 10.4381 8.5851 11.282 7.73533C12.1259 6.88555 12.6 5.73301 12.6 4.53125ZM18 9.0625C18.9548 9.0625 19.8705 9.44442 20.5456 10.1242C21.2207 10.8041 21.6 11.7261 21.6 12.6875C21.6 13.6489 21.2207 14.5709 20.5456 15.2508C19.8705 15.9306 18.9548 16.3125 18 16.3125C17.0452 16.3125 16.1295 15.9306 15.4544 15.2508C14.7793 14.5709 14.4 13.6489 14.4 12.6875C14.4 11.7261 14.7793 10.8041 15.4544 10.1242C16.1295 9.44442 17.0452 9.0625 18 9.0625ZM18 18.125C18.7091 18.125 19.4113 17.9844 20.0665 17.7111C20.7216 17.4378 21.3169 17.0373 21.8184 16.5324C22.3198 16.0275 22.7176 15.428 22.9889 14.7683C23.2603 14.1086 23.4 13.4016 23.4 12.6875C23.4 11.9734 23.2603 11.2664 22.9889 10.6067C22.7176 9.94695 22.3198 9.34753 21.8184 8.84261C21.3169 8.33769 20.7216 7.93717 20.0665 7.66391C19.4113 7.39065 18.7091 7.25 18 7.25C17.2909 7.25 16.5887 7.39065 15.9335 7.66391C15.2784 7.93717 14.6831 8.33769 14.1816 8.84261C13.6802 9.34753 13.2824 9.94695 13.011 10.6067C12.7397 11.2664 12.6 11.9734 12.6 12.6875C12.6 13.4016 12.7397 14.1086 13.011 14.7683C13.2824 15.428 13.6802 16.0275 14.1816 16.5324C14.6831 17.0373 15.2784 17.4378 15.9335 17.7111C16.5887 17.9844 17.2909 18.125 18 18.125ZM14.6981 21.75H21.2962C24.345 21.75 26.8312 24.1572 26.9887 27.1875H9.00562C9.16313 24.1572 11.6494 21.75 14.6981 21.75ZM14.6981 19.9375C10.5581 19.9375 7.2 23.3189 7.2 27.4877C7.2 28.3203 7.86937 29 8.70187 29H27.3037C28.1306 29 28.8056 28.326 28.8056 27.4877C28.8 23.3189 25.4419 19.9375 21.3019 19.9375H14.7037H14.6981ZM28.8 1.8125C29.5161 1.8125 30.2028 2.09894 30.7092 2.6088C31.2155 3.11867 31.5 3.81019 31.5 4.53125C31.5 5.25231 31.2155 5.94383 30.7092 6.4537C30.2028 6.96356 29.5161 7.25 28.8 7.25C28.0839 7.25 27.3972 6.96356 26.8908 6.4537C26.3845 5.94383 26.1 5.25231 26.1 4.53125C26.1 3.81019 26.3845 3.11867 26.8908 2.6088C27.3972 2.09894 28.0839 1.8125 28.8 1.8125ZM28.8 9.0625C29.9935 9.0625 31.1381 8.5851 31.982 7.73533C32.8259 6.88555 33.3 5.73301 33.3 4.53125C33.3 3.32949 32.8259 2.17695 31.982 1.32717C31.1381 0.477398 29.9935 0 28.8 0C27.6065 0 26.4619 0.477398 25.618 1.32717C24.7741 2.17695 24.3 3.32949 24.3 4.53125C24.3 5.73301 24.7741 6.88555 25.618 7.73533C26.4619 8.5851 27.6065 9.0625 28.8 9.0625ZM29.7 12.6875C32.1862 12.6875 34.2 14.7152 34.2 17.2188C34.2 17.7172 34.605 18.125 35.1 18.125C35.595 18.125 36 17.7172 36 17.2188C36 13.7127 33.1819 10.875 29.7 10.875H24.975C25.1213 11.4527 25.2 12.0645 25.2 12.6875H29.7ZM10.8 12.6875C10.8 12.0645 10.8787 11.4527 11.025 10.875H6.3C2.81812 10.875 0 13.7127 0 17.2188C0 17.7172 0.405 18.125 0.9 18.125C1.395 18.125 1.8 17.7172 1.8 17.2188C1.8 14.7152 3.81375 12.6875 6.3 12.6875H10.8Z"/>
    </svg>`,
            },
            {
                key: BULK_EDIT_STEPS.EDIT_FIELDS,
                label: "Modificar<br>KPIs",
                icon: `<svg width="22" height="29" viewBox="0 0 22 29" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.3333 27.1875H3.66667C2.6526 27.1875 1.83333 26.3775 1.83333 25.375V3.625C1.83333 2.62246 2.6526 1.8125 3.66667 1.8125H11V8.15625C11 9.65723 12.2318 10.875 13.75 10.875H20.1667V25.375C20.1667 26.3775 19.3474 27.1875 18.3333 27.1875ZM13.75 9.0625C13.2458 9.0625 12.8333 8.65469 12.8333 8.15625V1.84082C12.9938 1.88047 13.1427 1.95977 13.2573 2.07871L19.8974 8.64336C20.0177 8.76231 20.0979 8.90391 20.138 9.0625H13.75ZM3.66667 0C1.64427 0 0 1.62559 0 3.625V25.375C0 27.3744 1.64427 29 3.66667 29H18.3333C20.3557 29 22 27.3744 22 25.375V9.2834C22 8.56406 21.7078 7.87305 21.1922 7.36328L14.5578 0.798633C14.0422 0.288867 13.3432 0 12.6156 0H3.66667ZM6.41667 14.5C5.9125 14.5 5.5 14.9078 5.5 15.4062C5.5 15.9047 5.9125 16.3125 6.41667 16.3125H15.5833C16.0875 16.3125 16.5 15.9047 16.5 15.4062C16.5 14.9078 16.0875 14.5 15.5833 14.5H6.41667ZM6.41667 18.125C5.9125 18.125 5.5 18.5328 5.5 19.0312C5.5 19.5297 5.9125 19.9375 6.41667 19.9375H15.5833C16.0875 19.9375 16.5 19.5297 16.5 19.0312C16.5 18.5328 16.0875 18.125 15.5833 18.125H6.41667ZM6.41667 21.75C5.9125 21.75 5.5 22.1578 5.5 22.6562C5.5 23.1547 5.9125 23.5625 6.41667 23.5625H15.5833C16.0875 23.5625 16.5 23.1547 16.5 22.6562C16.5 22.1578 16.0875 21.75 15.5833 21.75H6.41667Z"/>
    </svg>`,
            },
            {
                key: BULK_EDIT_STEPS.CONFIRMATION,
                label: "Enviar<br>Validación",
                icon: `<svg width="36" height="29" viewBox="0 0 29 29" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M28.9784 2.08498C29.086 1.3995 28.7858 0.708357 28.2137 0.317464C27.6415 -0.0734301 26.8938 -0.107421 26.2877 0.238152L0.910249 14.7409C0.309801 15.0808 -0.0414046 15.7323 0.00391223 16.4234C0.0492291 17.1146 0.479739 17.7207 1.11418 17.987L9.06162 21.2954V26.564C9.06162 27.9123 10.1549 29 11.4974 29C12.2395 29 12.9362 28.6658 13.4007 28.0879L16.3916 24.3489H16.3973L22.8663 27.0455C23.3817 27.2608 23.9652 27.2268 24.4524 26.9549C24.9395 26.683 25.2737 26.2014 25.3587 25.6519L28.984 2.08498H28.9784ZM14.6469 23.6238L11.9846 26.9549C11.8656 27.1022 11.6843 27.1872 11.4974 27.1872C11.1519 27.1872 10.8743 26.9096 10.8743 26.564V22.0489L14.6469 23.6238ZM17.0884 22.6777L11.6164 20.3947L26.8541 3.98847L23.563 25.3743L17.094 22.6777H17.0884ZM25.5173 2.75913L9.83201 19.6525L1.81092 16.3101L25.5173 2.75913Z"/>
    </svg>`,
            },
        ];
        // Initialize bulk edit service
        const bulkEditService = useBulkEdit({
            period: props.period,
        });
        // Editable columns state
        const editableColumns = ref([]);
        onMounted(() => {
            setEditableColumns();
        });
        watch(() => props.fields, () => {
            setEditableColumns();
        });
        const setEditableColumns = () => {
            editableColumns.value = [];
            props.fields.forEach(field => {
                if (isNumObjetivos.value) {
                    if (field.key.includes('objetivos_conseguidos_rev_rows')) {
                        const month = field.key.split('.')[1];
                        editableColumns.value.push({
                            key: month,
                            label: field.label,
                            value: "",
                            isValid: true,
                            data: {
                                month: Number(month)
                            }
                        });
                    }
                }
                if (isRedRevisada.value) {
                    if (field.children && field.children.find(child => child.key.includes('red_revisada'))) {
                        editableColumns.value.push({
                            key: field.key,
                            label: field.label,
                            value: "",
                            isValid: true,
                        });
                    }
                }
            });
        };
        // Delegacion options
        const delegacionOptions = computed(() => {
            if (isDistribuidor.value) {
                return props.data.map((d, k) => ({ label: d.distribuidor, value: k }));
            }
            else if (isDelegacionZonaVentas.value) {
                return props.data.map((d, k) => ({ label: d.delegacion_zona_de_ventas, value: k }));
            }
            else {
                return props.data.map((d, k) => ({ label: d.delegacion + " - " + d.sala + " - " + d.distribuidor, value: k }));
            }
        });
        // Delegacion validation
        const delegacionLineCount = computed(() => bulkEditService.getLineCount(bulkEditService.formData.value.delegacionZonaDeVentas));
        const isDelegacionValid = computed(() => {
            const value = bulkEditService.formData.value.delegacionZonaDeVentas;
            if (!value.trim())
                return false;
            return bulkEditService.validateColumnLineCount(value, 1);
        });
        // Update column validation when values change
        watch(() => editableColumns.value.map((col) => col.value), () => {
            editableColumns.value.forEach((col) => {
                col.isValid = bulkEditService.validateColumnLineCount(col.value, 1);
            });
        }, { deep: true });
        // Validation
        const hasValidationErrors = computed(() => {
            if (delegacionLineCount.value > 0 && !isDelegacionValid.value)
                return true;
            return editableColumns.value.some((col) => !col.isValid);
        });
        const fieldsBeingModified = computed(() => {
            return editableColumns.value.filter((col) => col.value.trim() !== "");
        });
        // Navigation utilities
        const getCurrentStepIndex = () => BULK_EDIT_STEPS_LIST.indexOf(currentStep.value);
        const isNavigableStep = (step) => step !== BULK_EDIT_STEPS.LOADING && step !== BULK_EDIT_STEPS.RESULT;
        // Navigation helpers
        const showStepper = computed(() => isNavigableStep(currentStep.value));
        const showPrevButton = computed(() => {
            const currentIndex = getCurrentStepIndex();
            // Show prev button if not on first step and on a navigable step
            return currentIndex > 0 && isNavigableStep(currentStep.value);
        });
        const showCancelButton = computed(() => {
            return currentStep.value !== BULK_EDIT_STEPS.LOADING;
        });
        const showNextButton = computed(() => {
            const currentIndex = getCurrentStepIndex();
            // Show next button if not on confirmation step and on a navigable step
            return currentIndex >= 0 && currentStep.value !== BULK_EDIT_STEPS.CONFIRMATION && isNavigableStep(currentStep.value);
        });
        const showConfirmButton = computed(() => {
            return currentStep.value === BULK_EDIT_STEPS.CONFIRMATION;
        });
        const showRetryButton = computed(() => {
            var _a;
            return currentStep.value === BULK_EDIT_STEPS.RESULT && !((_a = result.value) === null || _a === void 0 ? void 0 : _a.success);
        });
        const showBackToEditButton = computed(() => {
            var _a;
            return currentStep.value === BULK_EDIT_STEPS.RESULT && !((_a = result.value) === null || _a === void 0 ? void 0 : _a.success);
        });
        const canProceedToNext = computed(() => {
            switch (currentStep.value) {
                case BULK_EDIT_STEPS.SELECT_DELEGATION:
                    // return !!bulkEditService.formData.value.delegation;
                    return bulkEditService.formData.value.delegation != null;
                case BULK_EDIT_STEPS.EDIT_FIELDS:
                    return !hasValidationErrors.value && fieldsBeingModified.value.length > 0;
                default:
                    return false;
            }
        });
        const canConfirm = computed(() => {
            return bulkEditService.formData.value.justification.trim().length > 0;
        });
        // Methods
        const open = () => {
            var _a;
            // Reset state
            currentStep.value = BULK_EDIT_STEPS.SELECT_DELEGATION;
            result.value = null;
            bulkEditService.formData.value = {
                delegation: null,
                objectiveId: null,
                delegacionZonaDeVentas: "",
                columns: [],
                justification: "",
            };
            editableColumns.value.forEach(col => {
                col.value = "";
                col.isValid = true;
            });
            return ((_a = dialogRef.value) === null || _a === void 0 ? void 0 : _a.open()) || Promise.resolve({ action: "close" });
        };
        const handleNext = () => {
            if (!canProceedToNext.value)
                return;
            const currentIndex = getCurrentStepIndex();
            if (currentIndex >= 0 && currentIndex < BULK_EDIT_STEPS_LIST.length - 1) {
                currentStep.value = BULK_EDIT_STEPS_LIST[currentIndex + 1];
            }
        };
        const handlePrev = () => {
            const currentIndex = getCurrentStepIndex();
            if (currentIndex > 0) {
                currentStep.value = BULK_EDIT_STEPS_LIST[currentIndex - 1];
            }
        };
        const handleConfirm = () => __awaiter(this, void 0, void 0, function* () {
            currentStep.value = BULK_EDIT_STEPS.LOADING;
            try {
                // Build request
                bulkEditService.formData.value.columns = editableColumns.value;
                if (!props.period)
                    throw new Error("Periodo no especificado");
                const delegation = props.data[bulkEditService.formData.value.delegation];
                const dataRow = props.dataRows.find(row => {
                    if (isDelegacionZonaVentas.value) {
                        return row.delegacion_zona_de_ventas == delegation.delegacion_zona_de_ventas;
                    }
                    else {
                        return row.delegacion == delegation.delegacion && row.sala == delegation.sala;
                    }
                });
                yield editableColumns.value.forEach((field) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c, _d, _e;
                    if (field.value) {
                        let request = {
                            delegacion: delegation.delegacion,
                            sala: delegation.sala,
                            distribuidor: delegation.distribuidor,
                            delegacion_zona_de_ventas: delegation.delegacion_zona_de_ventas,
                            mes_natural: (_b = (_a = field.data) === null || _a === void 0 ? void 0 : _a.month) !== null && _b !== void 0 ? _b : props.period.month,
                            ano_natural: props.period.year,
                            objective_type: field.key,
                            // red_revisada_ant: dataRow[field.key]['red_revisada']?.toString() ?? dataRow[field.key]['porcentaje_red']?.toString(),
                            // red_revisada: field.value,
                            // num_objetivos_conseguidos_ant: dataRow[field.key]['num_objetivos_conseguidos']?.toString() ?? dataRow[field.key]['num_objetivos_conseguidos']?.toString(),
                            // num_objetivos_conseguidos: field.value,
                        };
                        if (isNumObjetivos.value) {
                            request['num_objetivos_conseguidos_ant'] = (_d = (_c = dataRow['periods'][field.key]['objetivos_conseguidos_rev_rows']) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : (_e = dataRow['periods'][field.key]['num_objetivos_conseguidos']) === null || _e === void 0 ? void 0 : _e.toString();
                            request['num_objetivos_conseguidos'] = field.value;
                        }
                        if (isRedRevisada.value) {
                            const currentRed = dataRow[field.key]['red_revisada'];
                            const porcentajeRed = dataRow[field.key]['porcentaje_red'];
                            request['red_revisada_ant'] = currentRed != null
                                ? String(isCatalunya.value ? Math.round(currentRed) : Math.round(currentRed * 100))
                                : porcentajeRed != null
                                    ? String(Math.round(porcentajeRed * 100))
                                    : null;
                            request['red_revisada'] = field.value;
                        }
                        // Submit
                        const response = yield sendChangeRequest(request, props.tab);
                        result.value = response;
                    }
                }));
                currentStep.value = BULK_EDIT_STEPS.RESULT;
            }
            catch (error) {
                console.error(">>Bulk edit error:", error);
                result.value = {
                    success: false,
                    message: "Error al comunicarse con el servidor",
                    errors: [error instanceof Error ? error.message : String(error)],
                };
                currentStep.value = BULK_EDIT_STEPS.RESULT;
            }
        });
        const handleRetry = () => {
            currentStep.value = BULK_EDIT_STEPS.CONFIRMATION;
        };
        const handleBackToEdit = () => {
            currentStep.value = BULK_EDIT_STEPS.EDIT_FIELDS;
        };
        const handleCancel = () => {
            var _a, _b, _c;
            const shouldReload = currentStep.value === BULK_EDIT_STEPS.RESULT && ((_a = result.value) === null || _a === void 0 ? void 0 : _a.success);
            // dialogRef.value?.close();
            if (shouldReload) {
                // Signal that data should be reloaded
                (_b = dialogRef.value) === null || _b === void 0 ? void 0 : _b.accept(true);
            }
            else {
                (_c = dialogRef.value) === null || _c === void 0 ? void 0 : _c.cancel();
            }
        };
        // Expose methods
        __expose({
            open,
        });
        const __returned__ = { props, dialogRef, currentStep, result, isDistribuidor, isDelegacionZonaVentas, isRedRevisada, isNumObjetivos, isCatalunya, stepsForStepper, bulkEditService, editableColumns, setEditableColumns, delegacionOptions, delegacionLineCount, isDelegacionValid, hasValidationErrors, fieldsBeingModified, getCurrentStepIndex, isNavigableStep, showStepper, showPrevButton, showCancelButton, showNextButton, showConfirmButton, showRetryButton, showBackToEditButton, canProceedToNext, canConfirm, open, handleNext, handlePrev, handleConfirm, handleRetry, handleBackToEdit, handleCancel, Dialog, Button, Select, get StepIndicator() { return StepIndicator; }, get BULK_EDIT_STEPS() { return BULK_EDIT_STEPS; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
